import Button from 'components/Form/Button';
import React, { useEffect, useState } from 'react';
import EmployeeBenefit from '../../../../../../assets/assets/employee-benefit.png';
import { Benefits } from 'service/dto/employee-benefit.dto';
import ConfirmModal from 'components/Modal/ConfirmModal';
import withCreatePortal from 'components/HOC/withCreatePortal';
import { useRemoveBenefitTrustee } from 'common/queries-and-mutations/employee-benefit';
import { Alert } from 'components/Toast';
import { toast } from 'react-toastify';

type Props = {
  assets: Benefits;
  trusteeId: number;
  onSuccess: () => void;
};

const EnhancedConfirmModal = withCreatePortal(ConfirmModal);

export default function EmployeeAssets({
  assets,
  trusteeId,
  onSuccess
}: Props) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showAskToConfirm, setShowAskToConfirm] = useState(false);
  const [selectedAssetId, setSelectedAssetId] = useState<number | null>(null);

  const { mutate, isSuccess, isError } = useRemoveBenefitTrustee();

  const handleDelete = () => {
    mutate({ assetId: selectedAssetId!, trusteeId });
  };

  useEffect(() => {
    if (isSuccess && !isError) {
      setShowAskToConfirm(false);
      setIsSubmitting(false);
      setSelectedAssetId(null);
      onSuccess();
      toast(<Alert message="Asset Successfully Removed" type="success" />);
    } else if (isError) {
      setIsSubmitting(false);
    }
  }, [isError, isSuccess]);

  return (
    <div>
      {assets?.map(asset => {
        return (
          <div className="mt-2 flex flex-col" key={asset.id}>
            <div className="w-full rounded-md bg-white shadow-sm">
              <div className="border-b border-[#E5E5E5]">
                <div className="flex items-center justify-between p-3 px-5">
                  <span className="text-base font-normal text-[#34475E]">
                    Employee Benefit
                  </span>
                </div>
              </div>
              <div className="flex flex-wrap items-center justify-between px-4 pb-1">
                <div className="mr-3 space-y-2">
                  <img
                    src={EmployeeBenefit}
                    className="h-[6.5rem] w-[6.5rem] object-contain"
                  />
                </div>
                <div className="my-2 mr-3 space-y-2">
                  <div className="text-xs font-medium text-slate-600 ">
                    Employer Name
                  </div>
                  <div className="text-xs text-slate-600 ">
                    {asset.employerName}
                  </div>
                </div>
                <div className="my-2 mr-3 space-y-2">
                  <div className="text-xs font-medium text-slate-600 ">
                    Employer Address
                  </div>
                  <div className="text-xs text-slate-600 ">
                    {asset.employerAddress}
                  </div>
                </div>
                <div className="my-2 mr-3 space-y-2">
                  <div className="text-xs font-medium text-slate-600 ">
                    Benefit Type
                  </div>
                  <div className="text-xs text-slate-600 ">
                    {asset.employeeBenefit}
                  </div>
                </div>
                <div className="my-2 mr-3 space-y-2">
                  <div className="text-xs font-medium text-slate-600 ">
                    Employee ID
                  </div>
                  <div className="text-xs text-slate-600 ">
                    {asset.employeeId}
                  </div>
                </div>
                <div className="mr-3 space-y-2">
                  <Button
                    variant="outline"
                    size="md"
                    className="w-[8rem] place-self-end rounded border border-[#FF6600] bg-[#FF66001A] text-sm text-[#FF6600] lg:ml-8"
                    label="Remove"
                    onClick={() => {
                      setShowAskToConfirm(true);
                      setSelectedAssetId(asset.id);
                    }}
                  ></Button>
                </div>
              </div>
            </div>
          </div>
        );
      })}
      {showAskToConfirm && selectedAssetId && (
        <EnhancedConfirmModal
          content="Are you sure you want to remove this asset?"
          onConfirm={() => {
            setIsSubmitting(true);
            handleDelete();
          }}
          onCancel={() => {
            setShowAskToConfirm(false);
          }}
          actionText="Yes, Remove"
          cancelText="No"
          title="Action Required"
          isSubmitting={isSubmitting}
        />
      )}
    </div>
  );
}
